import React, { useEffect } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import './Form.css'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      minHeight: 630,
      alignItems: 'center',
      fontFamily: 'Libre Franklin',
      fontWeight: 300,
      lineHeight: '32px',
      [theme.breakpoints.down(700)]: {
        flexDirection: 'column',
        height: '100%',
      },
    },
    textBlock: {
      color: '#FFFFFF',
      background: '#353755',
      padding: '160px 61px 105px 61px',
      maxWidth: 378,
      [theme.breakpoints.down(900)]: {
        maxWidth: 500,
      },
      [theme.breakpoints.down(750)]: {
        maxWidth: 400,
      },
      [theme.breakpoints.down(700)]: {
        maxWidth: 600,
        paddingTop: 40,
        paddingBottom: 20,
        paddingLeft: 55,
        paddingRight: 55,
      },
      [theme.breakpoints.down(600)]: {
        paddingLeft: 28,
        paddingRight: 28,
      },
    },
    title: {
      fontFamily: 'Quicksand',
      fontWeight: 600,
      fontSize: 40,
      lineHeight: '44px',
      [theme.breakpoints.down(700)]: {
        fontSize: 24,
        lineHeight: '32px',
      },
    },
    textMedium: {
      fontSize: 20,
      [theme.breakpoints.down(700)]: {
        fontSize: 16,
        lineHeight: '28px',
      },
    },
    formBlock: {
      color: '#555555',
      background: '#FFFFFF',
      padding: '90px 50px 25px 50px',
      width: '100%',
      minWidth: 400,
      maxWidth: 400,
      [theme.breakpoints.down(1025)]: {
        paddingLeft: 40,
      },
      [theme.breakpoints.down(900)]: {
        minWidth: 300,
        maxWidth: 500,
      },
      [theme.breakpoints.down(750)]: {
        minWidth: 200,
        maxWidth: 400,
      },
      [theme.breakpoints.down(700)]: {
        padding: '20px 0px 35px 0px',
      },
    },
  }),
)

const Form: React.FC = () => {
  const classes = useStyles()
  useEffect(() => {
    const scriptCode = document.createElement('script')
    scriptCode.src = `${process.env.PUBLIC_URL}/form.min.js`
    scriptCode.async = true
    document.body.appendChild(scriptCode)
  }, [])

  return (
    <div id="formContainer" className={classes.container} data-testid="marketoForm">
      <div className={classes.textBlock}>
        <div className={classes.title}>Interested in premium insights?</div>
        <div>
          <p className={classes.textMedium}>
            If you&apos;re looking for more in-depth Refinance Index data and insights we want to hear from you.
          </p>
          <p>
            Register your interest and be the first to know if these new paid premium features go live - we promise not
            to spam you.
          </p>
          <p>
            Find out more in our&nbsp;
            <a
              href="https://www.pexa.com.au/privacy-policy"
              target="_blank"
              rel="noreferrer"
              style={{ color: '#FFFFFF' }}
            >
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
      <div className={classes.formBlock}>
        <form id="mktoForm_3227" />
      </div>
    </div>
  )
}

export default Form
